/**
 * The Arabic word for each role, for the whole dashboard.
 *
 * WHY THIS FILE EXISTS. The dashboard used seven words for the driver role —
 * `الدلفري`, `الديلفرى`, `دليفري`, `كابتن`, `مندوب`, `شوفير` and
 * `عامل التوصيل` — and three for the customer role. The words came from
 * whoever wrote each screen. Import from here, and a new screen cannot invent
 * an eighth.
 *
 * THE WORDS ARE NOT THE DATABASE VALUES. `admin`, `vendor`, `delivery` and
 * `customer` are the values that the API and the apps send. They do not change.
 * Only the words on the screen come from here.
 *
 * TWO RULES FOR TEXT THAT IS NOT A LABEL:
 *
 * 1. When the text means ONE role, use that role's word. The reviewer on a
 *    review is a `زبون`. The person on an order is a `زبون`.
 * 2. When the text means an account of ANY role, write `الحساب`. Never write
 *    `مستخدم` — that was the old word for the customer role, so it reads as
 *    "customer" to an operator and hides which of the three pages they are on.
 *
 * WHY `السائق`. The market is Palestine. `السائق` is the word that the active
 * apps and the landing site already use most. `دلفري` and `دليفري` are borrowed
 * words, `شوفير` is informal, `كابتن` belongs in marketing, and `مندوب` is clear
 * but less common in this code. See admin#30.
 */
export const ROLE_LABELS = Object.freeze({
    admin: "مشرف",
    super_admin: "مشرف عام",
    vendor: "مطعم",
    delivery: "سائق",
    customer: "زبون",
});

/**
 * The DEFINITE singular — "السائق", not "سائق".
 *
 * Arabic needs it when the word is the second half of a construct: a column
 * headed «تقييم سائق» reads as "a rating of some driver", where «تقييم السائق»
 * is "the driver's rating". `ROLE_LABELS` stays indefinite because that is what
 * a standalone label and a count card want — «إضافة سائق», «١٢ سائق».
 */
export const ROLE_DEFINITE_LABELS = Object.freeze({
    admin: "المشرف",
    super_admin: "المشرف العام",
    vendor: "المطعم",
    delivery: "السائق",
    customer: "الزبون",
});

export const ROLE_PLURAL_LABELS = Object.freeze({
    admin: "المشرفين",
    vendor: "المطاعم",
    delivery: "السائقين",
    customer: "الزبائن",
});
